<template>
  <div class="flex-1" data-testid="sign-pending-table">
    <div class="d-flex flex-column gap-10">
      <bb-box
        data-testid="pending-row"
        v-for="row in tableRows"
        :key="`row-${row.id}`"
        class="bg-white border-radius-sm border-width-1 p-0 border-gray-30"
      >
        <bb-functional-accordion>
          <template #header>
            <div class="d-flex align-items-center gap-10 p-x-10 p-y-15">
              <div class="d-flex flex-column">
                  <span class="f-smallest f-gotham-bold f-color-gray">
                    {{ row.beneficiary[0] }}
                  </span>
                <span class="f-tiny f-gotham-medium f-color-gray-70">
                    {{ row.beneficiary[1] }}
                  </span>
              </div>
              <div class="d-flex flex-column m-l-a f-align-right f-gotham-bold">
                  <span class="f-smallest f-color-gray">
                    {{ row.formattedAmount }}
                  </span>
                <span
                  class="f-tiny"
                  :class="getPaymentStatusColor(row.status)"
                >
                    {{ row.status[2] }}
                  </span>
              </div>
            </div>
          </template>
          <div class="d-flex flex-column gap-10 p-x-10 p-b-10">
            <div class="f-tiny f-color-gray d-flex flex-column" v-if="row.status[0]">
                <span class="f-gotham-bold">
                  {{ columnLabels.status }}
                </span>
              <span class="f-gotham-book">
                   {{ translations.status[row.status[0]] }} {{ row.status[1] ? ' - ' + row.status[1] : '' }}
                </span>
            </div>
            <div class="f-tiny f-color-gray d-flex flex-column">
                <span class="f-gotham-bold">
                  {{ columnLabels.description }}
                </span>
              <span class="f-gotham-book">
                  {{ row.description || '-' }}
                </span>
            </div>
            <div class="f-tiny f-color-gray d-flex flex-column">
                <span class="f-gotham-bold">
                  {{ columnLabels.referenceNumber }}
                </span>
              <span class="f-gotham-book">
                  {{ row.referenceNumber || '-' }}
                </span>
            </div>
            <div class="f-tiny f-color-gray d-flex flex-column">
                <span class="f-gotham-bold">
                  {{ columnLabels.dateTime }}
                </span>
              <span class="f-gotham-book">
                  {{ row.dateTime }}
                </span>
            </div>
          </div>
        </bb-functional-accordion>
      </bb-box>
      <bb-box
        class="d-flex flex-column gap-10 bg-white p-x-10 border-radius-sm border-width-1 border-gray-30">
        <div class="d-flex justify-content-between f-gotham-bold f-color-gray">
          <span class="f-small">
            {{ translations.footer.totalAmount }}
          </span>
          <span class="f-smallest">
            {{ sumForSigning }}
          </span>
        </div>
        <bb-button
          data-testid="pending-go-back-button"
          :label="translations.button.returnBack"
          size="sm"
          color="gray"
          inverted
          @click="goBack"
        />
        <bb-button
          data-testid="pending-sign-button"
          :label="translations.button.accept"
          size="sm"
          v-bind="buttonProps"
          @click="onSign"
        />
      </bb-box>
    </div>
  </div>
</template>

<script>
import { OrderStatus } from '@bigbank/dc-common/clients/http/account/modules/pending-payments/pending-payment.types'
import pendingTableMixin from '@account/views/payments/pending/pending-table.mixin'
import { formatMoneyWithCurrency } from '@/plugins/numformat'
import { formatDate } from '@/plugins/dateFormatters'

export default {
  name: 'sign-pending-table-mobile',
  props: {
    buttonProps: {
      type: Object,
      required: true
    }
  },
  mixins: [pendingTableMixin],
  computed: {
    columnLabels () {
      return {
        dateTime: this.translations.column.orderDate,
        referenceNumber: this.translations.column.referenceNumber,
        status: this.translations.column.orderStatus,
        description: this.translations.column.description
      }
    },
    tableRows () {
      return this.pendingPayments.map(pending => {
        const statusWithTranslation = pending.orderStatus === OrderStatus.NotConfirmed ? '' : this.translations.status[pending.orderStatus] || pending.orderStatus
        const statusDescription = this.translations.statusDescription[pending.orderStatus] || ''
        return {
          id: pending.id,
          dateTime: formatDate(pending.orderDate),
          status: [pending.orderStatus, statusDescription, statusWithTranslation],
          beneficiary: [
            pending.recipientName,
            pending.recipientIban
          ],
          description: pending.description,
          referenceNumber: pending.referenceNumber,
          formattedAmount: formatMoneyWithCurrency(pending.amount, pending.currencyCode, this.locale)
        }
      })
    }
  }
}
</script>
